import { CausationEdge, CausationNode } from './CausationNode';


export const compareCausationNodes = (a: CausationNode, b: CausationNode): number =>
  (a.timeStampIso != null && b.timeStampIso != null) ?
		a.timeStampIso.localeCompare(b.timeStampIso) :
	(a.timeStampIso == null) ?
		1 :
	(b.timeStampIso == null) ?
		-1 :
		a.causationNodeIndex - b.causationNodeIndex;


/**
 * Walk the causation tree to identify all nodes that directly or indirectly
 * caused the `nodeCaused`. Includes the nodeCaused amongst the nodes returned.
 * @param nodeCaused The node to find all the causal nodes for, so that one can
 * construct and/or render a causation tree customized to that node.
 * @returns The set of all nodes that caused the nodeCaused, including the nodeCaused itself.
 */
export const getAllNodesCausingNode = (nodeCaused: CausationNode) =>{
	const resultSet = new Set<CausationNode>();
	const getAllNodesCausingNodeRecursive = (nodeCaused: CausationNode)=> {
		if (!resultSet.has(nodeCaused)) {
			resultSet.add(nodeCaused);
			for (const {node: causedByNode} of nodeCaused.causedBy) {
				getAllNodesCausingNodeRecursive(causedByNode);
			}
		}
	}
	getAllNodesCausingNodeRecursive(nodeCaused);
	return resultSet;
//	return [...resultSet].sort( (a, b) => a.causationNodeIndex - b.causationNodeIndex);
}

export const getTheIndexesOfAllNodesCausingNode = (nodeCaused: CausationNode): number[] => {
	return [...getAllNodesCausingNode(nodeCaused)].map( n => n.causationNodeIndex);
}

/**
 * Create a subgraph of a causation graph that includes only a subset of the
 * nodes in the original graph. The nodes in the subgraph are copies of the
 * original nodes modified to connect only to other nodes in the subgraph.
 * @param nodesToInclude The set of nodes to include in the subgraph.
 * @returns The subgraph as an array of nodes.
 */
export const createSubgraphReplicatingOnlyTheseNodes = (nodesToInclude: Iterable<CausationNode>) => {
	const originalToReplacement = new Map<CausationNode, CausationNode>();
	// Replicate all the nodes from the original graph that are to be included in the subgraph
	for (const nodeInOriginalGraph of nodesToInclude) {
		const subgraphNode: CausationNode = {...nodeInOriginalGraph};
		originalToReplacement.set(nodeInOriginalGraph, subgraphNode);
	}
	const subgraphNodes = [...originalToReplacement.values()]
	// Replace all the node references in the subgraph with the replacement nodes
	for (const subgraphNode of originalToReplacement.values()) {
		subgraphNode.willCause = subgraphNode.willCause.map( ({howInferred, node}) => 
			({howInferred, node: originalToReplacement.get(node)}))
			.filter( n => n.node != null) as CausationEdge[];
		subgraphNode.causedBy = subgraphNode.causedBy.map( ({howInferred, node}) => 
			({howInferred, node: originalToReplacement.get(node)}))
			.filter( n => n.node != null) as CausationEdge[];
	}
	return subgraphNodes;
}


